/**
 * True only on the demo copy of Connexx (connexx-demo.vercel.app), where the
 * Vercel project sets NEXT_PUBLIC_DEMO_MODE=true. Next.js inlines the value at
 * build time, so it must be read as the literal process.env property.
 */
export const isDemoMode = (): boolean =>
  process.env.NEXT_PUBLIC_DEMO_MODE === "true";
